module.exports = __webpack_public_path__ + "img/bome.a2011ce0.svg";